<template>
    <section class="menu3-box">
        <div class="menu3">
            <ul>
                <li><a @click="$router.push(`/`)" href="javascript:void(0)">首页</a></li>
                <li><a @click="$router.push(`/`)" href="javascript:void(0)">返回首页</a></li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name:"Menu2",
}
</script> 

<style lang="scss" scoped> 
.menu3-box{
    background: #313131;height: 50px;
    .menu3{
        width: 1200px;margin: 0 auto;
        ul{display: flex;flex-direction:row;justify-content: space-between;}
        li{font-size: 1.6em;float: left;line-height: 50px;
            a{color: white;padding:0 40px;}
        }
        li:hover{background:#4e92f7;}
    }
}
</style>